import { render, staticRenderFns } from "./QMyClientsSubmenu.vue?vue&type=template&id=c74b5bb8&"
import script from "./QMyClientsSubmenu.vue?vue&type=script&lang=js&"
export * from "./QMyClientsSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports